const Messages = {
    APP_TITLE : 'CDW Wallet',
    CURRENCY : {
        INR : '₹'
    },
    LOGIN : {
        TITLE : 'WALLET',
        SIGN_IN_MESSAGE : 'Sign in to continue',
        FORM_FIELDS : {
            EMAIL : {
                LABEL : 'Email Address',
                ERROR: {
                    NO_EMAIL_ENTERED : 'Email cannot be empty',
                    INVALID_EMAIL : 'Invalid email address'
                } 
            },
            PASSWORD : {
                LABEL : 'Password',
                ERROR: {
                    NO_PASSWORD_ENTERED : 'Password cannot be empty'
                }
            },
            SIGN_IN : "Sign In",
            FORGOT_PASSWORD : {
                LABEL : "Forgot Password? ",
                ACTION : "Click Here"
            }
        },
        SIGNING_YOU_IN : 'Signing you in',
        APP_ACCESS_MESSAGE_BANNER : 'This application is now available for CDW Chennai and Bengaluru co-workers.'
    },
    FORGOT_PASSWORD : {
        TITLE : 'CDW Wallet',
        PAGE_TITLE : 'Forgot Password',
        FORM_FIELDS : {
            EMAIL : {
                LABEL : 'Email Address',
                ERROR: {
                    NO_EMAIL_ENTERED : 'Email cannot be empty',
                    INVALID_EMAIL : 'Invalid email address'
                } 
            },
            SEND_EMAIL : "Send Email"
        },
        BACK_TO_LOGIN : "Back to Login",
        MODAL: {
            EMAIL_SENT : {
                TITLE : 'Email Sent',
                MESSAGE : 'An email with a new password has been sent to the registered email address',
                ACTIONS : {
                    BACK_TO_LOGIN : 'Back to Login'
                }
            }
        }
    },
    RESET_PASSWORD : {
        TITLE : 'CDW Wallet',
        PAGE_TITLE : 'Reset Password',
        PASSWORD_RULES : {
            TITLE : 'Password Requirements',
            MIN_CHARACTER_LIMIT : 'Must have atleast 6 characters',
            MAX_CHARACTER_LIMIT : 'Should not be more than 15 characters',
            COMBINATION : 'Can be a combination of letters or numbers'
        },
        FORM_FIELDS : {
            CURRENT_PASSWORD : {
                LABEL : 'Current Password',
                ERROR: {
                    NO_PASSWORD_ENTERED : 'Password cannot be empty'
                }
            },
            NEW_PASSWORD : {
                LABEL : 'New Password',
                ERROR: {
                    NO_PASSWORD_ENTERED : 'Password cannot be empty',
                    LENGTH_NOT_MET : 'Password should be atleast 6 characters',
                    LENGTH_EXCEEDED : 'Password cannot be more than 15 characters'
                }
            },
            RE_PASSWORD : {
                LABEL : 'Re-type New Password',
                ERROR: {
                    NO_PASSWORD_ENTERED : "Password cannot be empty",
                    NO_MATCH : "Passwords don't match"
                }
            },
            UPDATE_PASSWORD : "Update Password"
        },
        MODAL : {
            PASSWORD_UPDATED : {
                TITLE : 'Password Updated',
                MESSAGE : 'Your Wallet password has been updated. Please logout and login again.',
                ACTIONS : {
                    LOGOUT : 'Logout Now'
                }
            }
        }
    },
    SHOP : {
        TITLE : 'Shop',
        NO_ITEMS: 'No items available',
        CURRENT_LOCATION_NOTE: "Current location",
        LOCATION: {
            ACTION: {
                SAVE: 'Save',
                CANCEL: 'Cancel'
            }
        }
    },
    CART : {
        TITLE : 'Cart',
        PAY_NOW: 'Pay Now',
        PAYMENT_HEADING : 'Payment Details',
        TOTAL_BILL : 'Total Bill',
        NO_ITEMS: 'No items in cart',
        BACK_TO_SHOP : 'Back to Shop',
        LOW_BALANCE : {
            TITLE : 'Low Balance',
            MESSAGE : "You don't have enough balance to buy items"
        },
        LOW_CDW_BALANCE: {
            TITLE: 'Low CDW Cash Balance',
            MESSAGE: "You don't have enough CDW Cash balance to buy items. Please select the event cash option to try using your Event cash"
        },
        TRY_AGAIN : 'Try Again',
        GO_TO_HOME: 'Go to Home',
        GO_TO_LOGIN: 'Re-Login',
        PAYMENT_IN_PROGRESS : 'Payment In Progress',
        REMOVE_ITEM : 'Remove',
        ITEM_NOT_AVAILABLE : 'Item Not Available. Please remove',
        DELIVERY_MESSAGE : 'Review your order as cancellation or refund is not available. Please collect your items from the Cafeteria after payment is successful.',
        COMBINED_TRANSACTION_NOTE: 'Please be noted your CDW cash will be auto-deducted if Event cash is insufficient',
        DIFF_LOCATION_TRANSACTION_NOTE: "Please be noted your CDW cash will be applicable on your base location only. Switch to your current location in home page if you're currently in your base location",
        CART_HIGHLIGHTER : {
            VIEW_CART : 'View Cart',
            ITEMS : 'items',
            ITEM : 'item'
        },
        EVENT_CASH_OPTION : {
            MESSAGE: 'Check this to pay using your event cash',
            VALUE: 'event'
        },
        INSUFFICIENT_BALANCE: 'INSUFFICIENT_BALANCE',
    },
    ORDER_CONFIRMATION : {
        PAYMENT_SUCCESSFUL : 'Payment Successful',
        ORDER_SUMMARY : 'Order Summary',
        COLLECT_FOOD_MESSAGE : 'Please collect the food from the cafeteria.'
    },
    PROFILE : {
        WALLET_BALANCE: 'Wallet Balance',
        CDW_CASH_BALANCE: 'CDW Cash Balance',
        EVENT_CASH_BALANCE: 'Event Cash Balance',
        _CASH_BALANCE: "Cash Balance",
        RESET_PASSWORD: 'Reset Password',
        LOGOUT : 'LOGOUT',
        WALLET_EXPIRY_MESSAGE : 'Your current balance will expire at month end.'
    },
    TRANSACTIONS : {
        TITLE : "Transactions",
        SHOWING_50 : "Showing last 50 transactions",
        SHOWING_ALL : "Showing all transcations",
        VIEW_MORE_HELP : "To get details about old transactions, please reach out to Admin Team.",
        END_OF_TRANSACTIONS : "End of transactions summary",
        SALES_SUMMARY : {
            TODAY : "Today's Sales",
            MONTH : "This Month"
        },
        NO_TRANSACTIONS : 'No Transactions',
        MONEY_RECEIVED : 'Received Rupees ',
        EVENT_CASH_LEGEND: '*Paid through Event Cash'
    },
    ERROR_CODES : {
        ERR_GENERIC : {
            code : "ERR_GENERIC",
            title : 'Something went wrong',
            message : 'We are unable to process your request at this moment. Please try later.',
            subMessage : 'If this issue persists, please contact Admin Team.'
        },
        INVALID_JWT : {
            code : "INVALID_JWT",
            title : 'Access Token Mismatch'
        },
        INVALID_CREDENTIALS : {
            title : 'Invalid Credentials',
            message : 'Invalid Credentials',
            subMessage : 'If this issue persists, please contact Admin Team.'
        },
        INACTIVE_USER : {
            code : 'INACTIVE_USER',
            title : "User Account not active",
            message : "Your user account is either inactive or suspended. Please contact HR Team."
        },
        INVALID_OFFICE_CATEGORY : {
            code : "INVALID_OFFICE_CATEGORY",
            title : "Access Restricted for Remote Users",
            message : "You are not eligible to make payments through the Wallet as a remote user. Please contact HR Team."
        },
        INACTIVE_VENDOR : {
            title : "Vendor Account not active",
            message : "Your vendor account is either inactive or suspended. Please contact Admin Team."
        },
        INSUFFICIENT_BALANCE : {
            title : 'Insufficient Balance',
            message : "You don't have sufficient balance to make this purchase. Please refresh the page to view the updated balance.",
            subMessage : 'If this issue persists, please contact Admin Team.'
        },
        ERR_INTERNET_DISCONNECTED : {
            title : 'Network is offline',
            message : 'Please check your internet connection before proceeding to pay.',
            subMessage : 'If this issue persists, please contact Admin Team.'
        },
        ERR_BAD_REQUEST : {
            title : '',
            message : 'Invalid Credentials. Try Again'
        },
        ERR_NETWORK : {
            title : 'Server Not Reachable',
            message : 'We are unable to reach our server at this moment. Please try later.',
            subMessage : 'If this issue persists, please contact Admin Team.'
        },
        INVALID_EMAIL : {
            message : 'No matching email address found in our records. Try again.'
        },
        INVALID_PASSWORD : {
            message : "Your current password is invalid."
        },
        INVALID_ITEMS : {
            title : 'Item(s) not available',
            message : 'One or more items in your cart are not available now. Please remove the item(s) to proceed.'
        },
        NO_VENDORS_AVAILABLE : {
            title : 'Vendor not available',
            message : 'Currently, no vendors are allocated to your office location.',
        },
        EVENT_EXPIRED: {
            VALUE: 'EVENT_EXPIRED'
        },
        EVENT_STARTED: {
            VALUE: 'EVENT_STARTED'
        },
        ITEMS_MISMATCH: {
            VALUE: 'ITEMS_DO_NOT_MATCH',
            title: "Items doesn't get matched",
            message: "One or more selected items are not supplied by the chosen vendor. Please update your current location in Home page"
        },
        BASE_LOCATION_MISMACTH: {
            VALUE: 'BASE_LOCATION_CHANGED',
            title: "Base location is Changed",
            message: "Your base location has been updated. Please re-login into the app for the changes to reflect"
        },
        INVALID_PUBLIC_KEY:{
            title: "INVALID_PUBLIC_KEY",
            message: "We are unable to process your request at this moment. Please try later. If this issue persists, please contact Admin Team."
        },
        INVALID_ENCRYPTION: {
            title: "INVALID_ENCRYPTION",
            message: "Please refresh the browser and try again"
        }
    },
    MODAL: {
        WELCOME_MSG_DIFF_LOCATION: (eventLocation) => `We appreciate your participation in the event. As our event is happening in ${eventLocation}, we would like to intimate you that additional cash is credited in your account for your participation in our event. As you have different base location, Please select your location you’re currently at.`,
        WELCOME_MSG_SAME_LOCATION: (eventLocation) =>  `We appreciate your participation in the event. As our event is happening in ${eventLocation}, we would like to intimate you that additional cash is credited in your account for your participation in our event. Please make sure to use it. Enjoy!`,
        THANKS_MSG: 'Thank you for your participation in the event. Your time and attention are truly appreciated!',
        INTIMATE_LOGOUT_FOR_EVENT_START: `As you're a participant in our event, You are going to get your wallet updates now.`,
        GREET: 'Hello',
        SUBMIT: 'Submit',
        LOGOUT: 'Logout',
        RE_LOGIN: 'Re-Login',
        OKAY: 'Okay!'
    }

}

export default Messages;